export const heroImageMap = {
  'search-registration': 'https://images.unsplash.com/photo-1695388474402-ed805a890d8d?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'clearance': 'https://images.unsplash.com/photo-1773047747721-f75d546d7290?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'application': 'https://images.unsplash.com/photo-1635859890085-ec8cb5466806?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'office-actions': 'https://images.unsplash.com/photo-1758518730327-98070967caab?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'monitoring': 'https://images.unsplash.com/photo-1743796055664-3473eedab36e?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'statement-of-use': 'https://images.unsplash.com/photo-1616101001234-7320af4f1aa7?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'ownership-change': 'https://images.unsplash.com/photo-1758520144427-ddb02ac74e9d?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'portfolio': 'https://images.unsplash.com/photo-1569235186275-626cb53b83ce?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'registration': 'https://images.unsplash.com/photo-1582104272194-ce7407446649?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'enforcement': 'https://images.unsplash.com/photo-1758541213979-fe8c9996e197?q=80&w=2070',
  'assignments': 'https://images.unsplash.com/photo-1664463760781-f159dfe3af30?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'litigation': 'https://images.unsplash.com/photo-1505664063633-09c83ec50e3d?q=80&w=2070',
  'dmca': 'https://images.unsplash.com/photo-1608742213509-815b97c30b36?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'searches': 'https://images.unsplash.com/photo-1713557112617-e12d67bddc3a?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'applications': 'https://images.unsplash.com/photo-1758206523826-a65d4cf070aa?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'llc': 'https://images.unsplash.com/photo-1753164597612-5e71b83fda91?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'c-corp': 'https://images.unsplash.com/photo-1711637397406-0c5fe8165dc6?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  's-corp': 'https://images.unsplash.com/photo-1772588627527-db42040f3a8b?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'non-profit': 'https://images.unsplash.com/photo-1758599668429-121d54188b9c?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85'
};

export const whatIsImageMap = {
  'search-registration': 'https://images.unsplash.com/photo-1632433105322-e410c2a20e49?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'clearance': 'https://images.unsplash.com/photo-1622100223462-297e5aaeac9e?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'application': 'https://images.unsplash.com/photo-1774891937497-96df6a794bd9?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'office-actions': 'https://images.unsplash.com/photo-1774891937400-b5e32f719fae?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'monitoring': 'https://images.unsplash.com/photo-1625970488705-7de6f59ab834?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'statement-of-use': 'https://images.unsplash.com/photo-1758518730384-be3d205838e8?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'ownership-change': 'https://images.unsplash.com/photo-1758599543129-5269a8f29e68?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'portfolio': 'https://images.unsplash.com/photo-1762967029968-71e5019ecd5e?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'registration': 'https://images.unsplash.com/photo-1747491747398-c708be58efca?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'copyright-enforcement': 'https://images.unsplash.com/photo-1580894897591-ff1e18c89183?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'enforcement': 'https://images.unsplash.com/photo-1596574027151-2ce81d85af3e?q=80&w=2070',
  'assignments': 'https://images.unsplash.com/photo-1666018215790-867b14fe4822?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'litigation': 'https://images.unsplash.com/photo-1565688527174-775059ac429c?q=80&w=2070',
  'copyright-portfolio': 'https://images.unsplash.com/photo-1768158989131-64cbff67f292?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'dmca': 'https://images.unsplash.com/photo-1558544956-15f3c317e06a?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'searches': 'https://images.unsplash.com/photo-1581092335331-5e00ac65e934?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'patent-office-actions': 'https://images.unsplash.com/photo-1581094017399-34c4fb48c65b?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'applications': 'https://images.unsplash.com/photo-1766297248047-6ec337099802?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'llc': 'https://images.unsplash.com/photo-1773146916231-e6aeae932080?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'c-corp': 'https://images.unsplash.com/photo-1612946205641-3aad07604cd2?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  's-corp': 'https://images.unsplash.com/photo-1772588627373-729b0f47e5bb?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85',
  'non-profit': 'https://images.unsplash.com/photo-1758272134073-39aced2153e6?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85'
};

export const getProtectionImages = (serviceSlug) => {
  if (['search-registration', 'clearance', 'application'].includes(serviceSlug)) {
    return [
      'https://images.unsplash.com/photo-1599658880436-c61792e70672?q=80&w=2070',
      'https://images.unsplash.com/photo-1556155092-490a1ba16284?q=80&w=2070',
      'https://images.unsplash.com/photo-1553729459-efe14ef6055d?q=80&w=2070'
    ];
  }
  if (['registration', 'assignments', 'litigation'].includes(serviceSlug)) {
    return [
      'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?q=80&w=2070',
      'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?q=80&w=2070',
      'https://images.unsplash.com/photo-1478737270239-2f02b77fc618?q=80&w=2070'
    ];
  }
  if (['searches', 'applications', 'enforcement'].includes(serviceSlug)) {
    return [
      'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?q=80&w=2070',
      'https://images.unsplash.com/photo-1581094017399-34c4fb48c65b?q=80&w=2070',
      'https://images.unsplash.com/photo-1766297247287-9bf80d5f8281?q=80&w=2070'
    ];
  }
  if (['llc', 'c-corp', 's-corp', 'non-profit'].includes(serviceSlug)) {
    return [
      'https://images.unsplash.com/photo-1676276383603-adaf8967f71f?q=80&w=2070',
      'https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2070',
      'https://images.unsplash.com/photo-1770627000564-3feb36aecbcd?q=80&w=2070'
    ];
  }
  return [
    'https://images.unsplash.com/photo-1589330694653-ded6df03f754?q=80&w=2070',
    'https://images.unsplash.com/photo-1521737711867-e3b97375f902?q=80&w=2070',
    'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=2070'
  ];
};
